module.exports = __webpack_public_path__ + "img/bg-sign-out-fail.5405b15e.png";